import { MessageType } from '../enum';
import { CallType, EventType, Message } from '../model';

export function isEventMessage(message: Message): message is EventType {
  return message && message.messageType === MessageType.EVENT;
}

export function isCallMessage(message: Message): message is CallType {
  return message && message.messageType === MessageType.CALL;
}
